export default __webpack_public_path__ + "static/media/element_102.76c465d0.webp";